var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B71E3F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,140h74.2c6.8,0,12.4-5.2,12.4-11.5H26C26,134.8,31.6,140,38.4,140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.6,42c4.8,0,8.8,0.4,12.1,1.1c-2.5-23.2-23.6-41.4-49.2-41.4S28.8,19.9,26.3,43.1 c3.3-0.7,7.3-1.1,12.1-1.1H112.6z M92.5,21.9c2.6,0,4.6,1.9,4.6,4.3s-2.1,4.3-4.6,4.3c-2.6,0-4.6-1.9-4.6-4.3S89.9,21.9,92.5,21.9z  M75.5,13.2c2.6,0,4.6,1.9,4.6,4.3s-2.1,4.3-4.6,4.3c-2.6,0-4.6-1.9-4.6-4.3S72.9,13.2,75.5,13.2z M58.5,21.9 c2.6,0,4.6,1.9,4.6,4.3s-2.1,4.3-4.6,4.3s-4.6-1.9-4.6-4.3S55.9,21.9,58.5,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.1,73.1c-4.1,2.2-8.9,3.5-13.5,3.5c-4.7,0-9.1-1.4-12.7-3.9c-4.6,2.5-10.5,3.9-15.1,3.9 c-3.2,0-6.4-0.7-9.3-2c-2.9,1.3-6,2-9.3,2c-4.6,0-10.5-1.3-15.1-3.9c-3.6,2.5-8.1,3.9-12.7,3.9c-4.7,0-9.4-1.3-13.5-3.5 c-3,2.1-5,5.4-5,9.2c0,6.4,5.5,11.5,12.4,11.5h86.6c6.8,0,12.4-5.2,12.4-11.5C131.2,78.6,129.2,75.2,126.1,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,70.8c5.1,0,9.6-2.3,12.4-5.8c2.8,3.5,10.4,5.8,15.5,5.8c3.5,0,6.7-1.1,9.3-2.9c2.6,1.8,5.8,2.9,9.3,2.9 c5.1,0,12.6-2.3,15.5-5.8c2.8,3.5,7.3,5.8,12.4,5.8c8.5,0,18.6-5.8,18.6-14.4c0-2.9-6.2-8.6-12.4-8.6c-5.1,0-81.5,0-86.6,0 c-6.2,0-12.4,5.8-12.4,8.6C19.8,65.1,29.8,70.8,38.4,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.8,99.7L118.8,99.7c-0.1,1.5-0.6,3-1.8,4.1l-12.4,11.5c-1.2,1.1-2.8,1.7-4.4,1.7c-1.6,0-3.2-0.6-4.4-1.7 l-12.4-11.5c-1.2-1.1-1.8-2.6-1.8-4.1H32.2c-6.8,0-12.4,5.2-12.4,11.5c0,6.4,5.5,11.5,12.4,11.5h86.6c6.8,0,12.4-5.2,12.4-11.5 C131.2,104.8,125.6,99.7,118.8,99.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon-hamburger.ea4091839e352f1cd9b9fcf6a7746919.svg";
export { ForwardRef as ReactComponent };